// The one-line status banner under the shell's top bar: "Share link opened", "Settings imported",
// "That file is not a settings export". Module-scope zustand (root CLAUDE.md), set by the load paths
// and by the top bar's share / export / import actions, dismissed by the SE.

import { create } from 'zustand';

export interface Notice {
  tone: 'info' | 'error';
  text: string;
}

export interface NoticeState {
  notice: Notice | null;
}

export const initialState: NoticeState = { notice: null };

export const useNoticeStore = create<NoticeState>(() => ({ ...initialState }));

export const showNotice = (notice: Notice | null): void => useNoticeStore.setState({ notice });
